import { AuthService } from '../containers/auth/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(
    public auth: AuthService,
    public router: Router
  ) { }

  canActivate(): boolean {
    if (this.auth.getToken()) {
      this.router.navigateByUrl('/');
      return false;
    }
    return true;
  }

}
